export const lightGrey = (alpha = 1) => `rgba(238,238,238,${alpha})`;
export const blackTransparent = (alpha = 0) => `rgba(0,0,0,${alpha})`;
export const whiteTransparent = (alpha = 0) => `rgba(255,255,255,${alpha})`;
export const backgroundTransparent = (alpha = 0) => `rgba(6, 14, 29,${alpha})`;

export const COLOR = {
    primary: '#29D3CE',
    secondary: '#8839A2',
    error: '#C43100',
    success: '#89B613',
    background: '#000',
    lowContrast: '#252525',
    highContrast: '#FFFFFF',
    selectedChannel: '#666666',
    nowProgram: '#4c4c4c',

    LIGHT_TEAL: '#BFD1CD',
    DARK_GREY: 'rgb(26, 26, 26)',
    RETRY_ERROR_BUTTON: '#2264F4',
    BLACK: '#000000',
    WHITE: '#ffffff',
    RED: 'red',
    BLUE_RIBBON: '#1c6fee',
    COD_GRAY: '#151515',
    COD_GRAY_LIGHT: '#1A1A1A',
    LIGHT_GREY: '#2F2F2F',
    SILVER: '#c4c4c4',
    PARENTAL_RED: '#E30613',
    PARENTAL_ORANGE: '#EB5B25',
    PARENTAL_YELLOW: '#E3D700',
    PARENTAL_GREEN: '#6EB055',
    NEUTRAL: '#EEEEEE',
    CYAN: '#0FCBEA',
    JUMP_MARKER_RED: '#EE0011',
    WHITE_OVERLAY: (opacity: number) => `rgba(255,255,255,${opacity})`,
    BLACK_OVERLAY: (opacity: number) => `rgba(0,0,0,${opacity})`,
    ZIRCON: '#F4F9FF',
    KIDS_VIOLET: '#662D91',
    KIDS_YELLOW: '#F7931E',
    NEUTRAL_GRAY: '#979797',
};
